export default class FilesLockedError extends Error {
  constructor(filePath) {
    super('file locked: ' + filePath); // (1)
    this.name = 'FilesLockedError'; // (2)
    this.filePath = filePath;
  }
}
